import axios from 'axios';
import {tileNoLabel} from '../services/map';
import {sidebarSQL, getLayers, populationSQL, categorySQL, geoTypeSQL, comparisionSQL,
    boundSQL, dataTablesSQL, detailChartSQL, detailTableSQL, mapSQL, mapSQLPlain, overviewSummarySQL, overviewTable,
    businessOverviewSQL, selectDistinctFromTable, businessOverviewTableSQL } from '../sql/queries';
import { populationForecastSQL, populationForecastPyramidSQL, householdQuery, averageHouseholdQuery} from '../sql/populationForecastQueries';
import {multipliersSQL} from '../sql/economicModelQueries';
import {getEndpoint, geomTable, getPlurals, getTotals, getMapTotals } from '../utils/utils';
import {panBoundArray, boundArray} from '../data/state';
import {startSetFetchFail} from './error';

// SET RESPONSE
export const setResponse = (newState) => ({
  type: 'SET_RESPONSE',
  newState
})


//Note: Get all the table names first and then the first value of first group will be set as the default value
//TODO: this is really complicated and not good cause here we make 3 continuos axios requests
// and the next request depend on the data from previous one
// and also it has to wait for successful reponse of previous one
// Need to change to GraphQL and apollo server for better performance and code quality
export const startSetResponse = (geo_type, geo_name, profile) => {
//console.log('inside startSetResponse', geo_type, geo_name, profile)
    return(dispatch, getState) => {
        let state = getState().globalState; 

        return axios.get(getEndpoint(dataTablesSQL(profile)))
        .then(dataTables => {    
            //console.log('dataTables here', dataTables)
            let firstRow = dataTables.data.rows[0];
            
            let newState = {
                profile,
                data_table : firstRow,
                data_tables: dataTables.data.rows
            }
            dispatch(setResponse(newState));
            let state = getState().globalState;
            return axios.all([
                axios.get(getEndpoint(populationSQL(state.data_table.table_ending))),
                axios.get(getEndpoint(categorySQL(state.data_table.table_ending))),
              ])

        })
        .then(axios.spread( (populationData, categoryData ) => {
            const category = categoryData.data.rows[0].category
            const population = populationData.data.rows[0].population
            let state = getState().globalState;
            const newState = {
                populations: populationData.data.rows,
                categories: categoryData.data.rows,
                category: category,
                population: population,
                layers: getLayers({...state, category, population, ...state.data_table})
            }
            dispatch(setResponse(newState));
            state = getState().globalState; 
            return axios.all([
                axios.get(getEndpoint(sidebarSQL(geo_type, population, category, geo_name, state.data_table.table_ending))),
                axios.get(getEndpoint(detailChartSQL(geo_type, population, category, geo_name, state.data_table.table_ending, state.data_table.chart_order_clause))),
                axios.get(getEndpoint(detailTableSQL(geo_type, population, geo_name, state.data_table.table_ending))),
                axios.get(getEndpoint(comparisionSQL(geo_type, population, state.data_table.table_ending))),
                axios.get(getEndpoint(mapSQLPlain(state.geo_type, state.population, state.category, state.geo_name, state.data_table.table_ending))),
              ])

        }))
        .then(axios.spread( (sidebarData, detailChartData, detailTableData, comparisionData, mapTotal ) => {
            //console.log('sidebarData', sidebarData)
            let state = getState().globalState; 

            const newState = {
                sidebarData: sidebarData.data.rows,
                detailChartData: detailChartData.data.rows,
                detailTableData: detailTableData.data.rows,
                comparisionData: comparisionData.data.rows,
                categoryTotal: getTotals(detailTableData.data.rows),
                mapTotal: getMapTotals(mapTotal.data.rows)
            }
            dispatch(setResponse(newState));

        }))
        .catch(error => {
            console.log('error', error)
            dispatch({
                type: 'FETCH_FAIL',
                message: 'Something went wrong with Ajax request.',
              });
            throw(error);
        }); 
    }
};


export const startSetResponseForecast = (profile) => {
    //console.log('inside startSetResponse', profile)
        return(dispatch, getState) => {
            let state = getState().globalState; 
            return axios.all([ 
                axios.get(getEndpoint(dataTablesSQL(profile))),
            ])
            .then(axios.spread( ( populationForecastDataTables ) => {
                //console.log('first row', firstRow)
                let firstPopulationForecastRow = populationForecastDataTables.data.rows[0];
                let newState = {
                    profile,
                    populationForecast: {
                        table: firstPopulationForecastRow.table_ending,
                        tables: populationForecastDataTables.data.rows
                    }
                }
                dispatch(setResponse(newState));
                let state = getState().globalState;
                return axios.all([
                    axios.get(getEndpoint(populationForecastSQL( state.populationForecast.table))),
                  ])
    
            }))
            .then(axios.spread( ( populationForecastData ) => {
                //console.log('populationForecastData', populationForecastData)
                let state = getState().globalState; 
                const newState = {
                    populationForecast: {
                        table: state.populationForecast.table,
                        tables: state.populationForecast.tables,
                        categories: state.populationForecast.categories,
                        data: populationForecastData.data.rows,
                        year: populationForecastData.data.rows[0].year
                    },
                }
                dispatch(setResponse(newState));
    
            }))
            .catch(error => {
                throw(error);
            }); 
        }
    };

export const startSetMultiplier = (multiplier) => {

    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(multipliersSQL( multiplier))),
        ])
        .then(axios.spread( (multiplierResponse) => {    
            const newState = {
                economicModel: {
                    multiplier: multiplier,
                    multipliers: state.economicModel.multipliers,
                    table: multiplierResponse.data.rows
                }
            }
            dispatch(setResponse(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
};

    
export const startSetResponseEconomicModel = (profile) => {

    return(dispatch, getState) => {
        let state = getState().globalState; 
        
        return axios.all([
            axios.get(getEndpoint(selectDistinctFromTable('origin', 'prime_brisbane_em_multipliers', ''))),

        ])
        .then(axios.spread( (multiplierResponse) => {    
            const newState = {
                profile,
                economicModel: {
                    multiplier: multiplierResponse.data.rows[0].origin,
                    multipliers: multiplierResponse.data.rows,
                }
            }
            dispatch(setResponse(newState));
            state = getState().globalState;
            return axios.all([
                axios.get(getEndpoint(multipliersSQL(multiplierResponse.data.rows[0].origin))),
            ])
        }))
        .then(axios.spread( (multiplierTable) => { 
            const newState = {
                economicModel: {
                    multiplier: state.economicModel.multiplier,
                    multipliers: state.economicModel.multipliers,
                    table: multiplierTable.data.rows
                }
            }
            dispatch(setResponse(newState));
        }))
        .catch(error => {
            throw(error);
        })
    }
};
      
// SET_GEO_TYPE
export const setGeoType = (newState = {}) => ({
  type: 'SET_GEO_TYPE',
  newState
});

//Note: can not do axios.all here cause we need to get all the lists of geo_name first
// once get response, then we need to dispatch to set state
// then the sidebar value will get the state from new set state to do the second axios
export const startSetGeoType = (geo_type, detailView) => {

    return(dispatch, getState) => {
        let state = getState().globalState; 
        return axios.get(getEndpoint(geoTypeSQL(geo_type, state.data_table.table_ending)))
        .then(geoTypeData => {
            let geo_names= geoTypeData.data.rows;
            (geo_names.length > 1 && !detailView) ? geo_names.unshift({geo_name: `All ${getPlurals(geo_type)}`}) : geo_names;

            let newState = {
                geom_table: geomTable(geo_type),
                geo_type: geo_type,
                geo_names: geo_names,
                geo_name: geo_names[0].geo_name,
                layers: getLayers({...state, geo_type})
            }
            dispatch(setGeoType(newState));
            state = getState().globalState;
            return axios.all([
                axios.get(getEndpoint(sidebarSQL(state.geo_type, state.population, state.category, state.geo_name, state.data_table.table_ending))),
                axios.get(getEndpoint(detailChartSQL(state.geo_type, state.population, state.category, state.geo_name, state.data_table.table_ending, state.data_table.chart_order_clause))),
                axios.get(getEndpoint(detailTableSQL(state.geo_type, state.population, state.geo_name, state.data_table.table_ending))),
                axios.get(getEndpoint(mapSQLPlain(geo_type, state.population, state.category, state.geo_name, state.data_table.table_ending))),
                axios.get(getEndpoint(comparisionSQL(geo_type, state.population, state.data_table.table_ending))),

              ])
        })
        .then(axios.spread( (sidebarData, detailChartData, detailTableData, mapTotal, comparisionData) => {
            let newState;
                newState = {
                    sidebarData: sidebarData.data.rows,
                    detailChartData: detailChartData.data.rows,
                    detailTableData: detailTableData.data.rows,
                    comparisionData: comparisionData.data.rows,
                    categoryTotal: getTotals(detailTableData.data.rows),
                    mapTotal: getMapTotals(mapTotal.data.rows)
                }
            dispatch(setGeoType(newState));
        }))
        .catch(error => {
            throw(error);
        });
          
    }
}


// SET TableType
export const setDataTable = (newState = {}) => ({
    type: 'SET_DATA_TABLE',
    newState
})

//NOTE: here we do 2 ajax requests to get population and category, upon success population and category is updated to redux store.
// New state is used to get data for sidebar and map
export const startSetDataTable = (data_table) => {
    //console.log('startSetDataTable', data_table)
    return(dispatch, getState) => {
      let state = getState().globalState; 

      return axios.all([
        axios.get(getEndpoint(populationSQL(data_table.table_ending))),
        axios.get(getEndpoint(categorySQL(data_table.table_ending))),
      ])
    .then(axios.spread( (populationData, categoryData) => {
        let newState = {
            populations: populationData.data.rows,
            population: populationData.data.rows[0].population,
            categories: categoryData.data.rows,
            category: categoryData.data.rows[0].category,
            overviewSummary: []
        }
        dispatch(setDataTable(newState));
        state = getState().globalState;
        return axios.all([
            axios.get(getEndpoint(sidebarSQL(state.geo_type, state.population, state.category, state.geo_name, data_table.table_ending))),
            axios.get(getEndpoint(detailChartSQL(state.geo_type, state.population, state.category, state.geo_name, data_table.table_ending, data_table.chart_order_clause))),
            axios.get(getEndpoint(detailTableSQL(state.geo_type, state.population, state.geo_name, data_table.table_ending))),
            axios.get(getEndpoint(mapSQLPlain(state.geo_type, state.population, state.category, state.geo_name, data_table.table_ending))),
            axios.get(getEndpoint(comparisionSQL(state.geo_type, state.population, data_table.table_ending))),
          ])
    }))

    .then(axios.spread( (sidebarData, detailChartData, detailTableData, mapTotal, comparisionData ) => {
        //console.log('mapdetailTableDataData', mapData)
        //console.log('mapData', mapData)
        let newState = {
            data_table: data_table,
            sidebarData: sidebarData.data.rows,
            layers: getLayers({...state, data_table}),
            detailChartData: detailChartData.data.rows,
            detailTableData: detailTableData.data.rows,
            comparisionData: comparisionData.data.rows,
            categoryTotal: getTotals(detailTableData.data.rows),
            mapTotal: getMapTotals(mapTotal.data.rows)

        }
        dispatch(setDataTable(newState));
    }))
    .catch(error => {
        throw(error);
    }); 
    }
  };


  export const startSetDataTableCustom = (data_table) => {
    //console.log('startSetDataTableCustom', data_table)
    return(dispatch, getState) => {
      let state = getState().globalState; 

      return axios.all([
        axios.get(getEndpoint(overviewSummarySQL(data_table.table_ending))),
        axios.get(getEndpoint(overviewTable())),
        axios.get(getEndpoint(selectDistinctFromTable('year', 'prime_brisbane_ep_businessoverview', `WHERE type != 'Total Change'`))),
        axios.get(getEndpoint(selectDistinctFromTable('type', 'prime_brisbane_ep_businessoverview', `WHERE type != 'Total Change'`))),
        axios.get(getEndpoint(businessOverviewSQL(state.businessOverview.type, state.businessOverview.year))),
        axios.get(getEndpoint(businessOverviewTableSQL(state.businessOverview.year))),
      ])
    .then(axios.spread( (overviewSummaryData, overviewTable, years, types, businessOverview, table) => {
 
        let newState = {
            data_table: data_table,
            overviewSummary: overviewSummaryData.data.rows,
            overviewTable: overviewTable.data.rows,
            businessOverview: {
                years: years.data.rows,
                types: types.data.rows,
                data: businessOverview.data.rows,
                year: state.businessOverview.year,
                type: state.businessOverview.type,
                table: table.data.rows
            }
        }
        dispatch(setDataTable(newState));

    }))

    .catch(error => {
        throw(error);
    }); 
    }

  };
  
export const startSetBusinessOverviewData = () => {
    //console.log('type startSetCategory', type )
    return(dispatch, getState) => {
        const state = getState().globalState; 
        //console.log('state', state)
        return axios.all([
            axios.get(getEndpoint(selectDistinctFromTable('year', 'prime_brisbane_ep_businessoverview', `WHERE type != 'Total Change'`))),
            axios.get(getEndpoint(selectDistinctFromTable('type', 'prime_brisbane_ep_businessoverview', `WHERE type != 'Total Change'`))),
            axios.get(getEndpoint(businessOverviewSQL(state.businessOverview.type, state.businessOverview.year))),
            axios.get(getEndpoint(businessOverviewTableSQL(state.businessOverview.year))),
        ])
        .then(axios.spread( (years, types, businessOverview, table) => {    
            //console.log('response data overviewTable', overviewTable)
            const newState = {
                businessOverview: {
                    years: years.data.rows,
                    types: types.data.rows,
                    data: businessOverview.data.rows,
                    year: state.businessOverview.year,
                    type: state.businessOverview.type,
                    table: table.data.rows
                }
            }

            dispatch(setBusinessOverview(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
};  
// SET Business Overview
export const setBusinessOverview = (newState = {}) => ({
    type: 'SET_BUSINESS_OVERVIEW',
    newState
})

export const startSetBusinessOverviewTypeChange = (type) => {

    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(businessOverviewSQL(type, state.businessOverview.year))),
            axios.get(getEndpoint(businessOverviewTableSQL(state.businessOverview.year))),
        ])
        .then(axios.spread( (businessOverviewResponse, table) => {    
            const newState = {
                businessOverview: {
                    years: state.businessOverview.years,
                    types: state.businessOverview.types,
                    year: state.businessOverview.year,
                    data: businessOverviewResponse.data.rows,
                    type: type,
                    table: table.data.rows
                }
            }
            dispatch(setBusinessOverview(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
};

export const startSetYearChange = (year) => {

    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(businessOverviewSQL( state.businessOverview.type, year))),
            axios.get(getEndpoint(businessOverviewTableSQL(year))),
        ])
        .then(axios.spread( (businessOverviewResponse, table) => {    
            const newState = {
                businessOverview: {
                    years: state.businessOverview.years,
                    types: state.businessOverview.types,
                    type: state.businessOverview.type,
                    data: businessOverviewResponse.data.rows,
                    year: year,
                    table: table.data.rows
                }
            }
            dispatch(setBusinessOverview(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
};

export const startSetOverviewTableData = (table_ending) => {
    //console.log('type startSetCategory', type )
    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(overviewTable(table_ending))),
        ])
        .then(axios.spread( (overviewTable) => {    
            //console.log('response data overviewTable', overviewTable)
            const newState = {
                overviewTable: overviewTable.data.rows,
                
            }

            dispatch(setCategory(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
};  
export const startSetOverviewChange = (overview) => {
    //console.log('profile', profile)
    const newState = {
        overviewChartSelected: overview,
    }
    return(dispatch, getState) => {
        return dispatch(setCategory(newState));
    }
};

// SET PopulationType
export const setPopulation = (newState = {}) => ({
    type: 'SET_POPULATION',
    newState
})


export const startSetPopulation = (population) => {
    return(dispatch, getState) => {
      const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(sidebarSQL(state.geo_type, population, state.category, state.geo_name, state.data_table.table_ending))),
            axios.get(getEndpoint(detailChartSQL(state.geo_type, population, state.category, state.geo_name, state.data_table.table_ending, state.data_table.chart_order_clause))),
            axios.get(getEndpoint(detailTableSQL(state.geo_type, population, state.geo_name, state.data_table.table_ending))),
            axios.get(getEndpoint(mapSQLPlain(state.geo_type, population, state.category, state.geo_name, state.data_table.table_ending))),
            axios.get(getEndpoint(comparisionSQL(state.geo_type, population, state.data_table.table_ending))),
          ])
        .then(axios.spread( (sidebarData, detailChartData, detailTableData, mapTotal, comparisionData ) => {
            //console.log('setPopulation response data', detailTableData)
            const newState = {
                population: population,
                sidebarData: sidebarData.data.rows,
                layers: getLayers({...state, population}),
                detailChartData: detailChartData.data.rows,
                detailTableData: detailTableData.data.rows,
                comparisionData: comparisionData.data.rows,
                categoryTotal: getTotals(detailTableData.data.rows),
                mapTotal: getMapTotals(mapTotal.data.rows)
            }
            dispatch(setPopulation(newState));
        }))
        .catch(error => {
            throw(error);
        });
        
    }
  };

  // SET Category Type
export const setCategory = (newState = {}) => ({
    type: 'SET_CATEGORY',
    newState
})

//TODO: need to seperate data properly. This is a hack to make it work
export const startSetCategory = (category, type) => {
    //console.log('type startSetCategory', type )
    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(sidebarSQL(state.geo_type, state.population, category, state.geo_name, state.data_table.table_ending))),
        ])
        .then(axios.spread( (sidebarData) => {    
            //console.log('response data' )
            const newState = {
                category: category,
                sidebarData: sidebarData.data.rows,
                layers: getLayers({...state, category})

            }

            dispatch(setCategory(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
  };
  

    // SET Geo Name
export const setGeoName = (newState = {}) => ({
    type: 'SET_GEONAME',
    newState
})

export const startSetGeoName = (geo_name) => {
    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(sidebarSQL(state.geo_type, state.population, state.category, geo_name, state.data_table.table_ending))),
            axios.get(getEndpoint(boundSQL(state.geom_table, geo_name))),
            axios.get(getEndpoint(detailChartSQL(state.geo_type, state.population, state.category, geo_name, state.data_table.table_ending, state.data_table.chart_order_clause))),
            axios.get(getEndpoint(detailTableSQL(state.geo_type, state.population, geo_name, state.data_table.table_ending))),
            axios.get(getEndpoint(mapSQLPlain(state.geo_type, state.population, state.category, geo_name, state.data_table.table_ending))),
          ])
        .then(axios.spread( (sidebarData, mapData, detailChartData, detailTableData, mapTotal) => {
            const bounds = mapData.data.rows[0];
            const categoryTotal = detailTableData.data.rows.length > 0 ? getTotals(detailTableData.data.rows) : {total: 0};
            //console.log('mapData', mapData)
            const newState = {
                geo_name: geo_name,
                category: state.category,
                sidebarData: sidebarData.data.rows,
                layers: getLayers({...state, geo_name}),
                // map: {
                //     zoom: 11
                // },
                boundArray : [[bounds.miny, bounds.minx],[bounds.maxy, bounds.maxx]],
                detailChartData: detailChartData.data.rows,
                detailTableData: detailTableData.data.rows,
                categoryTotal: categoryTotal,
                mapTotal: getMapTotals(mapTotal.data.rows)
            }
            dispatch(setGeoName(newState));
        }))
        .catch(error => {
            throw(error);
        });;
    }
  };

    // SET Map Type
export const setMapType = (newState = {}) => ({
    type: 'SET_MAPTYPE',
    newState
})

export const startSetMapType = (mapType) => {
    return(dispatch, getState) => {
        //console.log('startSetMapType', tileNoLabel[mapType])
        return dispatch(setMapType({mapType:  tileNoLabel[mapType]}));
    }
};
    
    // SET Map Opacity
export const setMapOpacity = (newState = {}) => ({
    type: 'SET_MAP_OPACITY',
    newState
})

export const startSetMapOpacity = (opacity) => {
    return(dispatch, getState) => {
        const state = getState().globalState; 
        const newState = {
            opacity,
            layers: getLayers({...state, opacity}),
        }
        return dispatch(setMapOpacity(newState));
    }
};

// SET detailView
export const setDetailView = (newState = {}) => ({
    type: 'SET_DETAIL_VIEW',
    newState
})

export const startSetDetailView = (detailView) => {
    //console.log('detailView', detailView)
    const bound = detailView ? panBoundArray : boundArray;

    return(dispatch, getState) => {

        let state = getState().globalState;
        //console.log('state.data_table.table_ending', state.data_table.table_ending)
        let table_ending    
        // NOTE: NOT good cause this is a special case, and force the data to display ep_industrydivision content
        if(state.data_table.table_ending === 'ep_overviewsummary' || state.data_table.table_ending === 'ep_businessoverview') {
            table_ending = 'ep_industrydivision'
            let newState = {
                data_table: state.data_tables[0],
            }
            dispatch(setGeoType(newState));
        } else {
            table_ending = state.data_table.table_ending
        }

        return axios.get(getEndpoint(geoTypeSQL(state.geo_type, table_ending)))
        .then(geoTypeData => {
            let geo_names= geoTypeData.data.rows;
            (geo_names.length > 1 && !detailView) ? geo_names.unshift({geo_name: `All ${getPlurals(state.geo_type)}`}) : geo_names;

            let newState = {
                geom_table: geomTable(state.geo_type),
                geo_type: state.geo_type,
                geo_names: geo_names,
                geo_name: state.geo_name,
                detailView: detailView,
                boundArray: bound
            }
            dispatch(setDetailView(newState));
            state = getState().globalState;
            return axios.get(getEndpoint(sidebarSQL(state.geo_type, state.population, state.category, state.geo_name, table_ending)))
        })
        .then(res => {
            let newState = {
                sidebarData: res.data.rows,
            }
            dispatch(setGeoType(newState));
        })
        .catch(error => {
            throw(error);
        });
    }    
};

// SET Profile
export const setProfile = (newState = {}) => ({
    type: 'SET_PROFILE',
    newState
})

export const startSetProfile = (profile) => {
    //console.log('profile', profile)
    const newState = {
        profile: profile,
    }
    return(dispatch, getState) => {
        return dispatch(setProfile(newState));
    }
};

// SET Population Forecast Category
export const setForecastCategory = (newState = {}) => ({
    type: 'SET_FORECAST_CATEGORY',
    newState
})

export const startSetForecastCategory = (category) => {
    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(populationForecastSQL( state.populationForecast.table))),
          ])
          .then(axios.spread( ( populationForecastData ) => {
            console.log('populationForecastData', populationForecastData)
            let state = getState().globalState; 
            const newState = {
                populationForecast: {
                    table: state.populationForecast.table,
                    tables: state.populationForecast.tables,
                    categories: state.populationForecast.categories,
                    data: populationForecastData.data.rows,
                    selectedCategory: category
                }
            }
            dispatch(setForecastCategory(newState));

        }))
        .catch(error => {
            throw(error);
        });
    }
};

// SET Population Forecast Table
export const setForecastCategories = (newState = {}) => ({
    type: 'SET_FORECAST_TABLE',
    newState
})

export const startSetForecastCategories = (table) => {
    //console.log('startSetForecastCategories table', table)
    return(dispatch, getState) => {
        const state = getState().globalState; 
        let sql ='';
        if(table === 'pf_agegend') {
            sql = populationForecastSQL( table);
        } else if (table === 'pf_householdnumber') {
            sql = householdQuery( table);
        }  else if (table === 'pf_householdsize') {
            sql = averageHouseholdQuery( table);
        } else {
            sql = populationForecastPyramidSQL(state.populationForecast.year, table);
        }
        //console.log('sql', sql)
        return axios.all([
            axios.get(getEndpoint(sql)),
          ])
          
        .then(axios.spread( ( populationForecastData ) => {
            //console.log('populationForecastData', populationForecastData)
            let state = getState().globalState; 
            const newState = {
                populationForecast: {
                    table: table,
                    tables: state.populationForecast.tables,
                    data: populationForecastData.data.rows,
                    year: populationForecastData.data.rows[0].year
                }
            }
            dispatch(setResponse(newState));

        }))
        .catch(error => {
            throw(error);
        });
    }
};

    // SET year slider
    export const setYearSlider = (newState = {}) => ({
        type: 'SET_YEAR_SLIDER',
        newState
    })
    
    export const startSetYearSlider = (year) => {
        return(dispatch, getState) => {
            const state = getState().globalState; 
            let sql = populationForecastPyramidSQL(year, state.populationForecast.table);
            
            //console.log('sql', sql)
            return axios.all([
                axios.get(getEndpoint(sql)),
              ])
              
            .then(axios.spread( ( populationForecastData ) => {
                //console.log('populationForecastData', populationForecastData)
                let state = getState().globalState; 
                const newState = {
                    populationForecast: {
                        table: state.populationForecast.table,
                        tables: state.populationForecast.tables,
                        data: populationForecastData.data.rows,
                        year: year
                    }
                }
                dispatch(setResponse(newState));
    
            }))
            .catch(error => {
                throw(error);
            });
        }
    };

// SET  Economic Model
export const setEconomicModel = (newState = {}) => ({
    type: 'SET_ECONOMIC_MODEL',
    newState
})

export const startSetEconomicModel = (type) => {

    return(dispatch, getState) => {
        const state = getState().globalState; 
        return axios.all([
            axios.get(getEndpoint(selectDistinctFromTable('origin', 'prime_brisbane_em_multipliers', ''))),

        ])
        .then(axios.spread( (multiplierResponse) => {    
            const newState = {
                economicModel: {
                    multiplier: multiplierResponse.data.rows[0].origin,
                    multipliers: multiplierResponse.data.rows
                }
            }
            dispatch(setBusinessOverview(newState));
        }))
        .catch(error => {
            throw(error);
        })
        
    }
};


// WEBPACK FOOTER //
// ./src/actions/globalState.js